import { hiddenField, optionField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  organization_id: optionField({ required: true }),
  store_group: optionField(),
  equivalent_item: optionField({ required: true })
};

export default config;
